__turbopack_context__.v({
  "category-name": "order-details-module-scss-module__AUlZha__category-name",
  "category-type": "order-details-module-scss-module__AUlZha__category-type",
  "container": "order-details-module-scss-module__AUlZha__container",
  "continue-container": "order-details-module-scss-module__AUlZha__continue-container",
  "divider": "order-details-module-scss-module__AUlZha__divider",
  "image": "order-details-module-scss-module__AUlZha__image",
  "image-container": "order-details-module-scss-module__AUlZha__image-container",
  "image-container-no-selection": "order-details-module-scss-module__AUlZha__image-container-no-selection",
  "image-loading": "order-details-module-scss-module__AUlZha__image-loading",
  "image-no-selection": "order-details-module-scss-module__AUlZha__image-no-selection",
  "image-no-selection-loading": "order-details-module-scss-module__AUlZha__image-no-selection-loading",
  "include": "order-details-module-scss-module__AUlZha__include",
  "includes-item": "order-details-module-scss-module__AUlZha__includes-item",
  "infos-container": "order-details-module-scss-module__AUlZha__infos-container",
  "options": "order-details-module-scss-module__AUlZha__options",
  "options-container": "order-details-module-scss-module__AUlZha__options-container",
  "plan-includes": "order-details-module-scss-module__AUlZha__plan-includes",
  "plan-infos": "order-details-module-scss-module__AUlZha__plan-infos",
  "price": "order-details-module-scss-module__AUlZha__price",
  "title": "order-details-module-scss-module__AUlZha__title",
  "title-mobile": "order-details-module-scss-module__AUlZha__title-mobile",
  "title-price": "order-details-module-scss-module__AUlZha__title-price",
});
